import { ShadToolTipType } from '../../types/components'
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip'

/**
 * Shadcn Tooltip 包装
 * - 支持传入延迟、方位、是否作为子组件包裹等控制
 */
export default function ShadTooltip({
  content,
  side,
  asChild = true,
  children,
  styleClasses,
  delayDuration = 500
}: ShadToolTipType): JSX.Element {
  return (
    <Tooltip delayDuration={delayDuration}>
      <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>

      <TooltipContent className={styleClasses} side={side} avoidCollisions={false} sticky="always">
        {content}
      </TooltipContent>
    </Tooltip>
  )
}
